// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".centralTable .el-table__body-wrapper{height:15.104vw!important;overflow-y:auto!important}", ""]);
// Exports
module.exports = exports;
